import React, { FC } from 'react';
import { type IconV2Props } from '../../IconV2';
import { cn } from '@express-labs/raven-tools';
import getDataIconAttribute from '../../helpers/getDataIconAttribute';
import s from '../../IconV2.scss';

const Locator24: FC<IconV2Props> = ({ icon, chroma }) => (
  <svg
    className={cn(
      chroma === 'dark' ? s.svgLight24 : s.svgDark24,
      `svg-icon--${icon}`
    )}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    data-icon={getDataIconAttribute(chroma, icon, '24')}
  >
    <path
      d="M12.498 4.5c3.304 0 6.002 2.576 6.002 5.754 0 2.15-2.436 6.432-5.59 11.029l-.412.6-.412-.6C8.943 16.703 6.5 12.403 6.5 10.254 6.5 7.077 9.197 4.5 12.498 4.5zm0 1C9.739 5.5 7.5 7.64 7.5 10.254c0 1.754 2.219 5.74 4.998 9.857 2.788-4.13 5.002-8.103 5.002-9.857 0-2.615-2.24-4.754-5.002-4.754zm.002 2.2c1.525 0 2.765 1.226 2.765 2.74 0 1.514-1.24 2.74-2.765 2.74-1.525 0-2.765-1.226-2.765-2.74 0-1.514 1.24-2.74 2.765-2.74zm0 1c-.975 0-1.765.78-1.765 1.74s.79 1.74 1.765 1.74c.975 0 1.765-.78 1.765-1.74S13.475 8.7 12.5 8.7z"
      fillRule="nonzero"
    />
  </svg>
);

export default Locator24;
